module.exports = {"name":"ContentOptimization","parameters":[{"name":"enableContentChangeReview","value":false}]}